<template>
  <OptionList />
</template>

<script>
import { mapActions } from 'vuex'

export default {
  components: {
    OptionList: () => import('@/components/Options/OptionList'),
  },

  props: {},

  data() {
    return {}
  },

  computed: {},

  created() { },

  beforeDestroy() {
    this.clearOptionsPage()
  },

  methods: {
    ...mapActions('optionStore', ['clearOptionsPage']),
  },
}
</script>

<style></style>
